import { v4 as uuid } from 'uuid';
import { format, parseISO } from 'date-fns';
import { getDayOfWeek } from '../../../helpers/utils/utils';
import { buscarHistoricoProcesso } from '../../../services/core/processos/processosService';

const ORDENACAO_HISTORICOS_PROCESSO = [
  'fixoAcomp,ASC', 'idProcessoAcompanhamento,ASC',
];


class HistoricoProcessoController {
  makeDateIndicator() {
    return {
      index: -1,
      unique: 0,
      getLabel(date) {
        return `${this.unique}?${date}`;
      },
      update(date, index, mapping) {
        if ((index - 1) === this.index && !mapping[this.getLabel(date)]) {
          this.unique += 1;
        }
        this.index = index;
      },
    };
  }

  makeItem(historico, dataHora) {
    const apelido = (historico.apelido && String(historico.apelido)) || '';
    const nomeUsuario = (historico.nomeUsuario && ` - ${String(historico.nomeUsuario)}`) || '';
    const email = (historico.email && ` - ${String(historico.email)}`) || '';
    return ({
      key: uuid(),
      idProcessoHistorico: historico.idProcessoHistorico,
      idTipoHistorico: historico.idTipoHistorico,
      descricaoTipo: historico.descricaoTipo && String(historico.descricaoTipo),
      dataHora,
      usuario: `${apelido}${nomeUsuario}${email}`,
      texto: historico.texto && String(historico.texto),
      faseAtualProcesso: historico.faseAtualProcesso && String(historico.faseAtualProcesso),
      faseSeguinteProcesso: historico.faseSeguinteProcesso && String(historico.faseSeguinteProcesso),
      fixar: historico.fixar && String(historico.fixar),
    });
  }

  makeItems(historicos = []) {
    if (historicos && historicos.length === 0) {
      return [];
    }

    const dateIndicator = this.makeDateIndicator();

    return historicos.reduce((mapping, historico, index) => {
      if (!historico.dataCadastramento) {
        return mapping;
      }

      const dataCompleta = parseISO(historico.dataCadastramento);
      const data = `${format(dataCompleta, 'dd/MM/yyyy')} - ${getDayOfWeek(dataCompleta.getDay())}`;
      const dataHora = format(dataCompleta, 'dd/MM/yyyy - HH:mm');

      dateIndicator.update(data, index, mapping);

      if (mapping[dateIndicator.getLabel(data)]) {
        return {
          ...mapping,
          [dateIndicator.getLabel(data)]: [...mapping[dateIndicator.getLabel(data)], this.makeItem(historico, dataHora)],
        };
      }

      return {
        ...mapping,
        [dateIndicator.getLabel(data)]: [this.makeItem(historico, dataHora)],
      };
    }, {});
  }

  async findAllFromPage(idProcesso, queryParams = {}, page = 0) {
    try {
      const response = await buscarHistoricoProcesso(idProcesso, ORDENACAO_HISTORICOS_PROCESSO, { page, ...queryParams });
      return { historicos: response.data, error: null };
    } catch (error) {
      return { error, historicos: [] };
    }
  }


  async findAllFromNextPage(idProcesso, oldersHistoricosResponse, queryParams = {}) {
    try {
      const data = await this.findAllFromPage(idProcesso, queryParams, oldersHistoricosResponse.number + 1);
      data.historicos.content = [...oldersHistoricosResponse.content, ...data.historicos.content];
      return { historicos: data.historicos };
    } catch (error) {
      return { error, historicos: oldersHistoricosResponse };
    }
  }
}

export const historicoProcessoController = new HistoricoProcessoController();
